import React from 'react';
import { Image } from '@fiverr-private/media';

export const OmrBadge = () => (
  <Image
    src="https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/eb1da68b5a3bd799b79c0ac3313f7eb6-1755084993843/OMR%20Q3.png"
    alt="OMR badge"
    display="block"
    width="auto"
    height={{
      default: '110px',
      lg: '130px',
    }}
  />
);
